import { CapacitorPassToWallet } from '@belongnet/capacitor-pass-to-wallet';
import { ProfilesApi } from '@up2stay/up2promo-api-client';

import { isCapacitorNative } from '@/core/utils/capacitor.utils';

async function toBase64(blob: Blob): Promise<string> {
  const bytes = new Uint8Array(await blob.arrayBuffer());
  let binary = '';
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary);
}

function downloadPass(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}

/**
 * Installs the profile's Wallet Card. On iOS the native Wallet sheet is
 * presented — a blob download does nothing inside the Capacitor WebView.
 */
export async function addProfileToWallet({
  profileId,
  fileName,
}: {
  profileId: string;
  fileName: string;
}): Promise<void> {
  const response = await ProfilesApi.downloadWalletPass({
    path: { id: profileId },
    responseType: 'blob',
  });
  const blob = response.data as Blob;

  if (isCapacitorNative()) {
    await CapacitorPassToWallet.addToWallet({ base64: await toBase64(blob) });
    return;
  }

  downloadPass(blob, fileName);
}
